/**
 * useI18n.ts — WEB.4.P1.5 — React hook that subscribes to `lang` and returns
 * a memoised translator.
 */

import { useCallback } from "react";
import { useGameStore } from "../store/game-store.js";
import type { LangCode } from "./i18n.js";
import { translate } from "./i18n.js";

export interface I18n {
  /** Active language code. */
  lang: LangCode;
  /** Translate a dot-path key with optional interpolation. */
  t: (key: string, vars?: Record<string, string | number>) => string;
}

export function useI18n(): I18n {
  const lang = useGameStore((s) => s.lang);
  const t = useCallback(
    (key: string, vars?: Record<string, string | number>) => translate(lang, key, vars),
    [lang],
  );
  return { lang, t };
}
